import React, { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import FavoriteButton from '../ui/favoriteButton/FavoriteButton'
import Title from '../ui/title/title'
import UserInfo from './userInfo'

import moment from 'moment-mini'
import { ContributionType } from '../../store/contributions/contributionsTypings'

interface Props {
    contribution: ContributionType
}

const ContributionHeader: React.FunctionComponent<Props> = ({ contribution }: Props) => {
    const [t] = useTranslation()
    const [isFavorite, setIsFavorite] = useState(contribution.is_favourite_for_user)
    return (
        <div className="headerWrapper">
            <div className="contributionHeader">
                <div className="titleAndFavorites">
                    <Title text={contribution.title} />
                    {/*@ts-ignore*/}
                    <FavoriteButton externalState={isFavorite} id={contribution.id} setExternalState={setIsFavorite} />
                    {contribution.user.nick && <UserInfo profile={contribution.user} />}
                </div>
                <div className="contributionInfo">
                    {t('Contribution')} {contribution.number} {t('submitted on')}
                    {moment(contribution.submit_date * 1000).format('DD/MM/YYYY')}
                </div>
            </div>
        </div>
    )
}

export default memo(ContributionHeader)
